import styled from 'styled-components'
import { SPACING } from '../../design/spacing/spacing.constants'

const FullWidthCardWrapper = styled.section`
  margin: 0 0 ${SPACING.M};
`

FullWidthCardWrapper.displayName = 'FullWidthCardWrapper'

export { FullWidthCardWrapper }
